import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from '../../authentication.service';
@Injectable({
  providedIn: 'root'
})
export class EscalationService {
 httpUrl:any
  constructor(private auth: AuthenticationService,private http:HttpClient) {
    this.httpUrl = this.auth.httpUrl;
  }

 

  async getEscalationRules(obj :any)  {
    const resp = await this.http.get<any>(this.httpUrl + '/sdp/admin/escalation/getEscalationRules' + obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async addEscalationRules(obj :any)  {
    const resp = await this.http.post<any>(this.httpUrl + '/sdp/admin/escalation/addEscalationRules' , obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

    async deleteEscalationRules(obj: any) {
    const res = await this.http.delete<any>(this.httpUrl + '/sdp/admin/escalation/deleteEscalationRules' + obj).toPromise().then(res => {
      return res;
    });
    return res;
  }


  async updateEscalationRules(obj: any) {
    const resp = await this.http.post<any>(this.httpUrl + '/sdp/admin/escalation/updateEscalationRules', obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

}